'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'radio-tuner';
var width = 512;
var height = 512;
var aliases = ["radio-alt"];
var unicode = 'f8d8';
var svgPathData = 'M485.7 55.3L509 49.6 497.6 3 474.3 8.7l-456 112L0 125.2 0 128l0 16L0 304l0 24L0 512l512 0 0-384-322.2 0 296-72.7zM320 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 336l128 0 16 0 0 32-16 0L80 368l-16 0 0-32 16 0zm16 64l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zM64 192l32 0 320 0 32 0 0 64-32 0L96 256l-32 0 0-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRadioTuner = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;